/* esm.sh - applesauce-common@5.2.0/dist/casts/bookmarks */
export * from "/*applesauce-common@5.2.0/esnext/dist/casts/bookmarks.mjs";
